<template>
  <div v-loading="isLoading" element-loading-text="Đang chuẩn bị dữ liệu..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="#f5f5f5">
    <div class="d-flex m-2">
      <el-select v-model="selectedAccount" filterable
                 placeholder="Tìm kiếm tài khoản..." size="sm"
                 class="flex-1" style="max-width: 450px" multiple>
        <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                   :value="account.accountId"></el-option>
      </el-select>
      <el-select v-model="selectedTagIds" filterable
                 placeholder="Lọc theo tag" size="sm" style="max-width: 450px"
                 class="flex-1 mx-2" multiple>
        <el-option v-for="tag in app.tags" :key="tag.id" :label="getTagName(tag)"
                   :value="tag.id"></el-option>
      </el-select>
      <el-select v-model="selectType">
        <el-option v-for="item in types" :key="item.val" :label="item.name"
                   :value="item.val">
        </el-option>
      </el-select>
      <div class="mx-2" style="margin-top: 1px">
        <DateRangePicker
          size="sm"
          ref="picker"
          opens="left"
          :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy', applyLabel: 'Áp dụng', cancelLabel: 'Hủy' }"
          :minDate="'2019/01/01'"
          :singleDatePicker="false"
          :ranges="false"
          :showWeekNumbers="true"
          :showDropdowns="true"
          :autoApply="false"
          v-model="dateRange"
          :linkedCalendars="true"
        >
          <template v-slot:input="picker">
                <span style="line-height: 25px; padding: 0 10px;"
                >Từ <b>{{ picker.startDate.toLocaleDateString("vi") }}</b> &nbsp; &nbsp; Đến
                  <b> {{ picker.endDate.toLocaleDateString("vi") }} </b></span
                >
          </template>
        </DateRangePicker>
      </div>
      <div>
        <el-button size="medium" @click="fetchStatistic()" type="primary">Tổng hợp</el-button>
      </div>
    </div>
    <div style="max-height: calc(100vh - 150px) ; overflow-y: auto">
      <el-card class="m-2" v-if="slider.interval<100">
        <vue-slide-bar :speed="0.05" v-model="slider.interval" :showTooltip="false"
                       :lineHeight="10"
                       style="padding-top: 4px !important;"
                       :isDisabled="true" />
        <div class="mt-2  font-size-14">Đang tải dữ liệu {{ slider.interval }} %</div>
      </el-card>
      <div class="d-flex mt-1">
        <el-card class="mx-2 flex-1">
          <dashboard-item
            desc="Tin nhắn đến"
            :val="total.webhook"
            src="/assets/icon/ic_chat_1.svg"
          />
        </el-card>
        <el-card class="flex-1">
          <dashboard-item
            desc="Tin nhắn gửi đi"
            :val="total.webhookReceived"
            src="/assets/icon/ic_chat_2.svg"
          />
        </el-card>

        <el-card class="mx-2 flex-1">
          <dashboard-item
            desc="Tin nhắn gửi qua Salework"
            :val="total.sent"
            src="/assets/icon/ic_chat_3.svg"
          />
        </el-card>
      </div>
      <el-card class="m-2">
        <div slot="header">
          Tin nhắn
        </div>
        <apexchart type="area" height="450" :options="chartOptions" :series="series"></apexchart>
      </el-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DashboardItem from "@/components/dashboard/DashboardItem";

export default {
  name: "OverviewStatistical",
  components: { DashboardItem, DateRangePicker },
  data() {
    return {
      selectedTagIds: [],
      types: [
        { name: "Tất cả liên hệ", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" },
        { name: "Zalo OA", val: "page" }
      ],
      selectType: "all",
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      accounts: [],
      selectedAccount: [],
      overviewId: "",

      series: [],
      chartOptions: {
        chart: {
          height: 400,
          type: "area",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        labels: [],
        xaxis: {
          type: "datetime",
          categories: []
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },
      seriesAccount: [],
      isLoading: false,
      slider: {
        interval: 0,
        total: 0,
        index: 0
      },
      total: {
        sent: 0,
        webhook: 0,
        webhookReceived: 0
      }
    };
  },
  methods: {
    getTagName(tag) {
      if (tag.assign) {
        return tag.name + " (*)";
      }
      return tag.name;
    },
    getAccounts() {
      this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = resp.data;
        this.fetchStatistic();
      });
    },
    fetchStatistic() {
      let startTime = this.dateRange.startDate.setHours(0, 0, 0, 0);
      let endTime = this.dateRange.endDate.setHours(23, 59, 59, 999);
      this.overviewId = startTime.toString() + "_" + endTime.toString() + "_" + new Date().getTime();
      this.series = [];
      this.chartOptions.xaxis.categories = [];
      this.seriesAccount = [];
      let data = [];
      if (this.selectedAccount.length == 0) {
        this.accounts.forEach((acc) => {
          data.push(acc.accountId);
        });
      } else {
        data.push(...this.selectedAccount);
      }
      if (data.length > 0) {
        this.isLoading = true;
        this.getStatistic({
          accountIds: data,
          id: this.overviewId,
          type: this.selectType,
          statisticType: "overview",
          startTime: startTime,
          endTime: endTime,
          tagIds: this.selectedTagIds
        });
      }
    },
    getStatistic(request) {
      let url = "/api/statistic/overview";
      this.$http.post(url, request).then(((res) => {
        this.slider.total = res.data;
        this.slider.index = 0;
      }));
    },
    calculateStatistic() {
      if (this.seriesAccount.length > 0) ;
      {
        this.series = [];
        this.total = {
          sent: 0,
          webhook: 0,
          webhookReceived: 0
        };
        let categories = [];
        this.seriesAccount.forEach((acc) => {

          let filter = categories.filter((c) => c == acc.date);
          if (filter == null || filter.length == 0) {
            categories.push(acc.date);
          }
        });
        // this.chartOptions.xaxis.categories = categories;
        let sentData = { name: "Tin nhắn gửi qua salework", data: [] };
        let webhookData = { name: "Tin nhắn đã đến", data: [] };
        let webhookReceivedData = { name: "Tin nhắn đã gửi", data: [] };
        categories = categories.sort((a, b) => new Date(b) - new Date(a));
        categories.forEach((cat) => {
          let sent = 0;
          let webhook = 0;
          let webhookReceived = 0;
          this.seriesAccount.forEach((acc) => {
            if (acc.date == cat) {
              sent += acc.sent;
              webhook += acc.webhook;
              webhookReceived += acc.webhookReceived;
              this.total.sent += acc.sent;
              this.total.webhook += acc.webhook;
              this.total.webhookReceived += acc.webhookReceived;
            }

          });
          webhookData.data.push(webhook);
          webhookReceivedData.data.push(webhookReceived);
          sentData.data.push(sent);
        });

        this.series.push(webhookData);
        this.series.push(webhookReceivedData);
        this.series.push(sentData);
        this.setOption(categories);
      }
    },
    setOption(categories) {
      this.chartOptions = {
        chart: {
          height: 400,
          type: "area",
          zoom: {
            enabled: false
          },
          toolbar: {
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ",",
                headerCategory: "Thời gian",
                headerValue: "value",
                dateFormatter(timestamp) {
                  let date = new Date(timestamp);
                  date.setHours(date.getHours() - 7);
                  var minutes = ("0" + date.getMinutes()).slice(-2);
                  var hours = ("0" + date.getHours()).slice(-2);
                  var day = ("0" + date.getDate()).slice(-2);
                  var month = ("0" + (date.getMonth() + 1)).slice(-2);
                  return day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
                }
              },
              svg: {
                filename: undefined
              },
              png: {
                filename: undefined
              }
            },
            autoSelected: "zoom"
          }

        },
        dataLabels: {
          enabled: false
        },

        labels: [],
        xaxis: {
          type: "datetime",
          categories: categories
        },
        tooltip: {
          x: {
            format: "yyyy-MM-dd HH:mm:ss.mmm"
          }
        }
      };
    },
    updateStatistic(data) {
      if (data.id == this.overviewId) {
        this.isLoading = false;
        let filter = this.seriesAccount.filter((acc) => acc.newId == data.newId);
        if (filter == null || filter.length == 0) {
          this.seriesAccount.push(data);
          this.updateSlider();
          if (this.slider.interval == 100) {
            this.calculateStatistic();
          }
        }
      }
    },
    updateSlider() {
      this.slider.index += 1;
      this.slider.interval = ((this.slider.index / this.slider.total) * 100).toFixed(2);
    }
  },
  beforeDestroy() {
    this.$bus.$off("overview_event");
  },
  created() {
    // this.dateRange.startDate.setDate(this.dateRange.startDate.getDate() - 1);
    this.$bus.$on("overview_event", (data) => {
      this.updateStatistic(data);
    });
    this.getAccounts();
  }
};
</script>

<style scoped>

</style>
